import { Logger } from "aws-amplify"
import { getPresenceForVehicles, SearchOrgVehicles } from "@/services/API.js"
import { getCoor, getColor, getStatus, isUnknown } from "@/utils"
const logger = new Logger("presence mixin")

export const presence = {
  methods: {
    // on somes pages we may need to load a list of vehicles and their presence, this provides a generic function to do so
    // you can see an example of this on the my files page (Cloud.vue)
    $loadVehicles(org = false, idList = [], loadPresence = true) {
      logger.debug("load vehicles", idList, loadPresence)
      return new Promise(async res => {
        if(!idList || !idList.length || !org) {
          res([])
        } else {
          let Vehicles = await SearchOrgVehicles(org, false, false, true, 1, 1000, idList)
          logger.info("what is this", Vehicles);
          // if we have no vehicles to load
          if(!Vehicles.Vehicles || !Vehicles.Vehicles.length) {
            res([])
          }

          // if we have the vehicles and don't want the presence, just return the vehicles
          else if(!loadPresence) {
            res(Vehicles.Vehicles)
          }

          // if we also want to load the vehicles presence
          else if(loadPresence) {
            await this.$loadPresence(org, Vehicles.Vehicles);

            res(Vehicles.Vehicles)
          }

          // shouldn't get here? but just incase :) 
          else {
            res([])
          }
        }
      })
    },

    // loads presence for the vehicle id list specified and updates the store
    // this can be used across the site with this mixin to fetch and keep updated the presence data for the visible vehicles
    // after this promise has returned, you can be sure that the regular devices presence global state should be available :) 
    $loadPresence(org = false, vehicles = [], subscribeToWebSockets = true) {

      if(!org || typeof org !== 'string') {
        logger.debug("no org was provided to load the vehicles / presence for")
        return false
      }

      // first, we set up the state for our vehicles.
      // this is used across the site to fetch things like names etc
      this.$store.commit("devicePresence/setVehicles", vehicles)

      // we use these two sets so we don't have to iterate through these responses more than once to link information
      const vehiclesSet = vehicles.reduce((set, item) => {
        set[item.id] = {
          id: item.id,
          vehicle_name: item.vehicle_name,
          vehicle_type: item.vehicle_type
        }
        return set
      }, {})

      let physicalDeviceIds = vehicles.map(i => {
        return i.devices && Array.isArray(i.devices) && i.devices.length && i.devices[0].physical_device_id
          ? i.devices[0].physical_device_id
          : false
      }).filter(i => i) // remove any devices that for some reason have no physical_device_id

      logger.debug("load presence", vehicles, physicalDeviceIds)

      // we return a promise so the calling component can also have direct access to the data if it needs, or wait for the response to finish
      // if it's required for some functionality :) 

      return new Promise(async (res) => {
        // pass the physical device id list to the API
        let presence = await getPresenceForVehicles(org, physicalDeviceIds)
       
        // next, we transform the response from the presence API into the format we have previously used for the site
        const precencesSet = presence.Presences.reduce((set, item) => {

          const { lat, long } = item.last_location.coords

          try {
            const device = {
              coor: { lat: getCoor(lat), lng: getCoor(long) },
              id: item.device_id,
              vehicle_id: item.vehicle_id,
              fillColor: getColor(item.status),
              name: vehiclesSet[item.vehicle_id] ? vehiclesSet[item.vehicle_id].vehicle_name : 'Vehicle',
              direction: isUnknown(item.last_location.course) ? 0 : parseInt(item.last_location.course),
              type: vehiclesSet[item.vehicle_id] ? vehiclesSet[item.vehicle_id].vehicle_type.toLowerCase() : 'car',
              mileage: item.mileage,
              acc: item.acc,
              status: getStatus(item.status),
              statusText: item.status,
              last_seen: item.last_seen,
              network_signal: item.network_signal,
              last_seen_local_time: item.last_seen_local_time,
              faults: item.faults,
              speed: isUnknown(item.current_speed) ? item.current_speed : Number(item.current_speed),
              //data: item,
              channels: ["CH1", "CH2", "CH3", "CH4"]
            }
            set[item.device_id] = device
          } catch (err) {
            logger.log("error setting vehicle", err)
          }
          return set
        }, {})

        this.$store.commit("devicePresence/setDefaultPresences", precencesSet)

        if(subscribeToWebSockets) {
          // the websocket presence subscription requires a list of vehicle ids
          let vehiclesIDList = vehicles.map(i => i.id)
          this.$subscribeToWebsockets(org, vehiclesIDList)
        }
       
        this.$nextTick(() => {
          res(JSON.parse(JSON.stringify(precencesSet)))
        })
      })
    },

    // same as above, but when you already have the devices response
    $setDevicePresence(org = false, presences = false) {
      return new Promise(res => {
        logger.debug("loadPresenceDevices", org, presences)
        try {
          res(true)
        }

        catch (err) {
          res(false)
        }
      })
    },

    // this can only be called after vehicles and devices have been loaded. this loads the mapData object needed for the map view
    $subscribeToWebsockets (orgId = false, vehiclesIDList) {
      window.EventBus.$emit('initializeMapData', orgId, vehiclesIDList)
    }
  }
}